export const images = {
  ariseHealthLogo:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a395a12aaf3_logo-01.svg',
  checkCircleDark:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a700a12aad4_check%20circle.svg',
  chevronCircleLeft:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a0e4912aadb_Chevron%20right-1.svg',
  chevronCircleRight:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a7ce212aacc_Chevron%20right.svg',
  companyLogoPlaceholder:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a332512aaee_placeholder-1.svg',
  doubleQuoteBlockLight:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a91e612aae8_quote-mark.svg',
  doubleQuoteRoundLight:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a6c9412aae6_double-quotes-l.svg',
  ephicientLogo:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a3cd712aaf6_logo-05.svg',
  facebookLogoBigDarkFilled:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a705912aaeb_facebook%20big%20filled.svg',
  facebookLogoCircleDark:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a4a9512aae0_product%20icon-1.svg',
  facebookLogoSmallDark:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a51bf12aae9_facebook%20small.svg',
  instagramLogoBigDark:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a61f512aaed_instagram%20big.svg',
  linkedinLogoCircleDark:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124ac76f12aaec_product%20icon-2.svg',
  linkedinLogoSmallDark:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a389912aad8_linkedin%20small.svg',
  oeLogo:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124ae38212aaf1_logo-03.svg',
  pipelinxLogo:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a753912aaf8_logo-07.svg',
  placeholderImageBalance:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a07fb12aae3_portfolio%203%20-%20wide.svg',
  placeholderImageCards:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124ace5e12aae4_portfolio%204%20-%20wide.svg',
  placeholderImageGallery:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a55c612aae2_portfolio%202%20-%20wide.svg',
  placeholderImageHills:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a28a812aad9_placeholder%202.svg',
  placeholderImageMountains:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124af1aa12aadf_placeholder%201.svg',
  placeholderImageOverlap:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a867e12aade_portfolio%201%20-%20wide.svg',
  placeholderImageSun:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a2a3312aae1_placeholder%203.svg',
  plusRotatedDark:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124ac2f812aadc_plus%20rotated.svg',
  rightArrowLight:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a29b112aac4_ic%20Arrow%20Go.svg',
  thePaakLogo:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124ade1612aaf2_logo-02.svg',
  toogetherLogo:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a85fd12aaf5_logo-08.svg',
  twentyLogo:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a411512aaf4_logo-04.svg',
  twitterLogoBigDark:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124ab37a12aaf0_twitter%20big.svg',
  twitterLogoCircleDark:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a853712aad7_product%20icon.svg',
  twitterLogoSmallDark:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124ac15112aad5_twitter%20small.svg',
  youtubeLogoBigDark:
    'https://uploads-ssl.webflow.com/62434fa732124a0fb112aab4/62434fa732124a717f12aaea_youtube%20small.svg',
};

export const prebuiltLayoutPreviewImages = {
  layoutFeaturesList:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutFeaturesList-preview@2x.46ef9df31e.png',
  layoutFeaturesMetrics:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutFeaturesMetrics-preview@2x.d66539f26d.png',
  layoutFeaturesTable:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutFeaturesTable-preview@2x.8c66580bdb.png',
  layoutFooterDark:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutFooterDark-preview@2x.58c2d1e6b4.png',
  layoutFooterLight:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutFooterLight-preview@2x.d988913e10.png',
  layoutFooterSubscribe:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutFooterSubscribe-preview@2x.1b2b43bb86.png',
  layoutGalleryOverview:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutGalleryOverview-preview@2x.607bbc45cf.png',
  layoutGalleryScroll:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutGalleryScroll-preview@2x.3663d0e741.png',
  layoutGallerySlider:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutGallerySlider-preview@2x.8803e92fc8.png',
  layoutHeroHeadingCenter:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutHeroHeadingCenter-preview@2x.138c425115.png',
  layoutHeroHeadingLeft:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutHeroHeadingLeft-preview@2x.fd9d3c1f21.png',
  layoutHeroHeadingRight:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutHeroHeadingRight-preview@2x.ca82ef7d1a.png',
  layoutHeroStack:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutHeroStack-preview@2x.0b010ddfe3.png',
  layoutHeroSubscribeLeft:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutHeroSubscribeLeft-preview@2x.00f95ce9ac.png',
  layoutHeroSubscribeRight:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutHeroSubscribeRight-preview@2x.3ef55e98b0.png',
  layoutHeroWithoutImage:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutHeroWithoutImage-preview@2x.6e2a8f25cd.png',
  layoutLogosQuoteBlock:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutLogosQuoteBlock-preview@2x.bae76d38a0.png',
  layoutLogosQuoteDivider:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutLogosQuoteDivider-preview@2x.97361426df.png',
  layoutLogosTitleLarge:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutLogosTitleLarge-preview@2x.7a60170c58.png',
  layoutLogosTitleSmall:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutLogosTitleSmall-preview@2x.e8362ec510.png',
  layoutLogosWithoutTitle:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutLogosWithoutTitle-preview@2x.1f96c12816.png',
  layoutNavbarLogoCenter:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutNavbarLogoCenter-preview@2x.3ce56e74da.png',
  layoutNavbarLogoLeft:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutNavbarLogoLeft-preview@2x.e9ffa19281.png',
  layoutNavbarNoShadow:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutNavbarNoShadow-preview@2x.e7845c31cf.png',
  layoutPricingComparison:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutPricingComparison-preview@2x.9f61687263.png',
  layoutPricingItems:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutPricingItems-preview@2x.9485dbb045.png',
  layoutPricingOverview:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutPricingOverview-preview@2x.eed308cc51.png',
  layoutTeamCircles:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutTeamCircles-preview@2x.e493c59c1d.png',
  layoutTeamSlider:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutTeamSlider-preview@2x.b751861e9c.png',
  layoutTestimonialColumnDark:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutTestimonialColumnDark-preview@2x.f1c7def9b5.png',
  layoutTestimonialColumnLight:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutTestimonialColumnLight-preview@2x.d696454d61.png',
  layoutTestimonialImageLeft:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutTestimonialImageLeft-preview@2x.8cc61d55ae.png',
  layoutTestimonialSliderLarge:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutTestimonialSliderLarge-preview@2x.ffdc5fb16b.png',
  layoutTestimonialSliderSmall:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutTestimonialSliderSmall-preview@2x.356ad8f0df.png',
  layoutTestimonialStack:
    'https://d3e54v103j8qbb.cloudfront.net/img/pbl-LayoutTestimonialStack-preview@2x.c5783befa3.png',
};
